import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const CompanyManagementIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 49 48">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 21.4286C6.708 21.4286 8.5 23.1566 8.5 25.2857V38.1429C8.5 40.272 6.708 42 4.5 42C2.292 42 0.5 40.272 0.5 38.1429V25.2857C0.5 23.1566 2.292 21.4286 4.5 21.4286ZM17.7933 6C19.98 6 21.756 7.71 21.756 9.81857V38.1814C21.756 40.29 19.9827 42 17.7933 42C15.6067 42 13.8333 40.29 13.8333 38.1814V9.81857C13.8333 7.71 15.6067 6 17.7933 6ZM31.1267 16.2857C33.3133 16.2857 35.0893 17.9957 35.0893 20.1043V38.1814C35.0893 40.29 33.316 42 31.1267 42C28.94 42 27.1667 40.29 27.1667 38.1814V20.1043C27.1667 17.9957 28.94 16.2857 31.1267 16.2857ZM44.5 26.5714C46.708 26.5714 48.5 28.2994 48.5 30.4286V38.1429C48.5 40.272 46.708 42 44.5 42C42.292 42 40.5 40.272 40.5 38.1429V30.4286C40.5 28.2994 42.292 26.5714 44.5 26.5714Z"
      fill="#007549"
    />
  </SvgIcon>
);
